import React, { useEffect } from "react";
import { BizsolDisconnectModalContentStep1 } from "@/components/organisms/BizsolDisconnectModalContentStep1";
import { BizsolDisconnectModalContentStep2 } from "@/components/organisms/BizsolDisconnectModalContentStep2";
import { BizsolDisconnectModalContentStep3 } from "@/components/organisms/BizsolDisconnectModalContentStep3";
import { useRecoilState } from "recoil";
import {
  BizsolDisconnectModalState,
  bizsolDisconnectModalState,
} from "@/store/bizsolDisconnectModalState";

type Props = {
  active: boolean;
  title: string;
  sub: string;
  username: string;
  onClickCancel: () => void;
  onClickDisconnect: (disconnectState: BizsolDisconnectModalState) => void;
};

export const BizsolDisconnectModal = ({
  active,
  title,
  sub,
  username,
  onClickCancel,
  onClickDisconnect,
}: Props) => {
  const [disconnectState, setDisconnectState] = useRecoilState(
    bizsolDisconnectModalState
  );

  useEffect(() => {
    setDisconnectState({ step: 1, temporaryPassword: "" });
  }, [active]);

  if (!active) {
    return <></>;
  }

  switch (disconnectState.step) {
    case 1:
      return (
        <BizsolDisconnectModalContentStep1
          title={title}
          sub={sub}
          onClickCancel={onClickCancel}
          onClickDisconnect={onClickDisconnect}
        />
      );
    case 2:
      return (
        <BizsolDisconnectModalContentStep2
          title={title}
          sub={sub}
          username={username}
          onClickCancel={onClickCancel}
        />
      );
    case 3:
      return (
        <BizsolDisconnectModalContentStep3
          title={title}
          username={username}
          onClickCancel={onClickCancel}
        />
      );
    default:
      return <></>;
  }
};
